import { ImageActions } from "../actions";
import { ActionTypes } from "../const/ActionTypes";

export interface ImageState {
    attachmentIds?: number[];
    attachmentId?: number;
}

export const imageReducer = (state: ImageState = {}, action: ImageActions): ImageState => {
    switch (action.type) {
        case ActionTypes.SET_ATTACHMENT_IDS:
            return {
                ...state,
                attachmentIds: action.value,
            };
        case ActionTypes.SET_CURRENT_ATTACHMENT_ID:
            return {
                ...state,
                attachmentId: action.value,
            };
        default:
            return state;
    }
};
